import {
    CustomRecordProperties,
    DiversionProperties,
    FcaProperties,
    GDFHotPollyTypes,
    GDFPalletCode,
    GDFRecordType,
    isRaimProduct,
    isTracksProduct,
    PirepProperties,
    RaimProperties,
    TcfDetails,
    TfrProperties,
    TrackProperties,
    TropicalCyclonesProperties,
    WatchesWarningsProperties,
    WeatherPickingInfoLayer,
    WeatherPickingInfoObject,
    WmoVolcano2Properties,
    WmoVolcanoProperties
} from '@fe/weather';
import { Dialog } from '@progress/kendo-react-dialogs';
import { useState } from 'react';
import { EventBus, useEvent } from '../../../app/contexts/event-bus';
import { WeatherDetailsWindowArgs } from '../../map-interaction/context-menu/WeatherContextMenu';

export function WeatherDetailsDialog() {
    const [details, setDetails] = useState<WeatherDetailsWindowArgs | null>(null);
    useEvent('weather-details-window-open', setDetails);

    if (!details) {
        return null;
    }
    return (
        <Dialog
            contentStyle={{ maxHeight: '80vh', maxWidth: '80vw' }}
            closeIcon={true}
            title={`Properties - ${details.layer.product.name}`}
            onClose={() => EventBus.fire('weather-details-window-open', null)}>
            <WeatherDetailsContent details={details} />
        </Dialog>
    );
}

function WeatherDetailsContent(props: { details: { layer: WeatherPickingInfoLayer; object: WeatherPickingInfoObject } }) {
    const { layer, object } = props.details;
    if (object.type === 'raster') {
        return <></>; // TODO: will we have a details dialog for raster products? don't think so
    }

    if (object.record.type === GDFRecordType.ccfp) {
        return <TcfDetails record={object.record} />;
    } else if (object.record.type === GDFRecordType.diversion) {
        return <DiversionProperties record={object.record} />;
    } else if (object.record.type === GDFRecordType.hotpoly && !object.record.reduced) {
        if (isTracksProduct(layer.product.id)) {
            return <TrackProperties record={object.record} />;
        } else if (props.details.layer.palette === GDFPalletCode.tfr) {
            return <TfrProperties record={object.record} />;
        } else if (
            object.record.polyType === GDFHotPollyTypes.watch_tornado ||
            object.record.polyType === GDFHotPollyTypes.watch_tstorm ||
            object.record.polyType === GDFHotPollyTypes.warning_tornado ||
            object.record.polyType === GDFHotPollyTypes.warning_tstorm
        ) {
            return <WatchesWarningsProperties record={object.record} />;
        }
    } else if (object.record.type === GDFRecordType.hotpolyhi) {
        if (isRaimProduct(layer.product.id) && !object.record.reduced) {
            return <RaimProperties record={object.record} />;
        } else if (layer.product.id === 0x6089 && !object.record.reduced) {
            return <TropicalCyclonesProperties record={object.record} />;
        } else if (
            !object.record.reduced &&
            (object.record.polyType === GDFHotPollyTypes.watch_tornado ||
                object.record.polyType === GDFHotPollyTypes.watch_tstorm ||
                object.record.polyType === GDFHotPollyTypes.warning_tornado ||
                object.record.polyType === GDFHotPollyTypes.warning_tstorm)
        ) {
            return <WatchesWarningsProperties record={object.record} />;
        }
    } else if (object.record.type === GDFRecordType.pirep2) {
        return <PirepProperties record={object.record} />;
    } else if (object.record.type === GDFRecordType.custom) {
        return <CustomRecordProperties record={object.record} />;
    } else if (object.record.type === GDFRecordType.wmovolcano) {
        return <WmoVolcanoProperties record={object.record} />;
    } else if (object.record.type === GDFRecordType.wmovolcano2) {
        return <WmoVolcano2Properties record={object.record} />;
    } else if (object.record.type === GDFRecordType.fca) {
        return <FcaProperties record={object.record} />;
    }

    return <></>;
}
